module.exports = __webpack_public_path__ + "static/media/7-11.36342b52.mp3";